import { render, staticRenderFns } from "./leadlist.vue?vue&type=template&id=40cadd2c&scoped=true&"
import script from "./leadlist.vue?vue&type=script&lang=js&"
export * from "./leadlist.vue?vue&type=script&lang=js&"
import style0 from "./leadlist.vue?vue&type=style&index=0&id=40cadd2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cadd2c",
  null
  
)

export default component.exports